import { Badge, type BadgeProps } from './Badge';
import { BadgeColor, BadgeSize } from '@components/Badge.types.ts';
import { JobStatus } from '@funnellab/shared/src/types/directus-enums.ts';
import { useOnlineUntil } from '@src/hooks/useOnlineUntil';
import { useTranslation } from 'react-i18next';

export const JobStatusBadge = ({
  state,
  nextRenewal,
  ...props
}: {
  state: JobStatus | null | undefined;
  nextRenewal: string | null | undefined;
} & Partial<BadgeProps>) => {
  const { t } = useTranslation('common', { keyPrefix: 'jobStatus' });
  const { formattedOnlineUntil } = useOnlineUntil(nextRenewal ?? null);

  let label: string;
  let color: BadgeColor;
  switch (state) {
    case JobStatus.DRAFT:
      label = t(JobStatus.DRAFT);
      color = BadgeColor.GREY;
      break;
    case JobStatus.OFFLINE:
      label = t(JobStatus.OFFLINE);
      color = BadgeColor.RED;
      break;
    case JobStatus.ONLINE:
      label = t(JobStatus.ONLINE);
      color = BadgeColor.GREEN;
      break;
    case JobStatus.SUBMITTED:
      label = t(JobStatus.SUBMITTED);
      color = BadgeColor.BLUE;
      break;
    case JobStatus.REACTIVATING:
      label = t(JobStatus.REACTIVATING);
      color = BadgeColor.YELLOW;
      break;
    case JobStatus.ONLINE_TERMINATED:
      label = t(JobStatus.ONLINE_TERMINATED, {
        liveUntil: formattedOnlineUntil,
      });

      color = BadgeColor.GREEN;
      break;
    default:
      return null;
  }
  return (
    <Badge
      size={BadgeSize.SMALL}
      deletable={false}
      showDot={false}
      {...props}
      label={label}
      color={color}
    />
  );
};
